<template>
  <div id="app">
    <div class="bg-gray-800 text-white">
      <div class="relative mx-auto flex justify-between items-center py-4">
        <div
          class="flex items-center flex-1 justify-center md:flex-none md:justify-start"
        >
          <router-link to="/" aria-label="Home">
            <img src="./assets/logo_white.png" class="h-10 w-auto md:ml-4" />
          </router-link>
        </div>
        <div v-if="user && user.email" class="hidden md:block">
          <div class="flex ml-10">
            <router-link
              to="/"
              class="px-3 py-2 rounded-md text-sm font-medium"
              :class="{ 'bg-gray-900': $route.path === '/' }"
            >
              Dashboard
            </router-link>
            <router-link
              to="/sales"
              class="ml-4 px-3 py-2 rounded-md text-sm font-medium"
              :class="{ 'bg-gray-900': $route.path === '/sales' }"
            >
              Sales Log
            </router-link>
            <router-link
              to="/shipping"
              class="ml-4 px-3 py-2 rounded-md text-sm font-medium"
              :class="{ 'bg-gray-900': $route.path === '/shipping' }"
            >
              Shipping Schedule
            </router-link>
            <router-link
              v-if="user && user.roles && user.roles.isAdmin"
              to="/admin"
              class="ml-4 px-3 py-2 rounded-md text-sm font-medium"
              :class="{ 'bg-gray-900': $route.path === '/admin' }"
            >
              Manage Users
            </router-link>
          </div>
        </div>
        <div class="hidden md:block">
          <div class="ml-4 flex items-center md:ml-6">
            <div v-if="user && user.email" class="mr-4 text-gray-400">
              {{ user.email }}
            </div>
            <div v-if="user && user.email">
              <a
                href="/logout"
                @click="handleLogout"
                class="px-3 py-2 rounded-md text-sm font-medium"
              >
                Logout
              </a>
            </div>
            <div v-else>
              <router-link
                to="/login"
                class="px-3 py-2 rounded-md text-sm font-medium"
              >
                Login
              </router-link>
            </div>
          </div>
        </div>
        <div class="md:hidden absolute right-3 inset-y-0 flex items-center">
          <button
            @click="showMenu = !showMenu"
            class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:bg-gray-700 focus:text-white"
            :aria-expanded="showMenu ? 'true' : 'false'"
          >
            <svg
              class="block h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
            <svg
              class="hidden h-6 w-6"
              :class="{ block: showMenu ? 'block' : 'hidden' }"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
      <div
        v-if="showMenu"
        class="md:hidden bg-gray-900"
        x-transition:enter="duration-150 ease-out"
        x-transition:enter-start="opacity-0 scale-95"
        x-transition:enter-end="opacity-100 scale-100"
        x-transition:leave="duration-100 ease-in"
        x-transition:leave-start="opacity-100 scale-100"
        x-transition:leave-end="opacity-0 scale-95"
      >
        <div class="px-2 pt-2 pb-3 space-y-1">
          <template v-if="user && user.email">
            <router-link
              to="/"
              class="block px-3 py-2 rounded-md text-base font-medium"
              :class="{ 'bg-gray-800': $route.path === '/' }"
            >
              Dashboard
            </router-link>
          <router-link
            to="/sales"
            class="block px-3 py-2 rounded-md text-base font-medium"
            :class="{ 'bg-gray-800': $route.path === '/sales' }"
          >
            Sales Log
          </router-link>
          <router-link
            to="/shipping"
            class="block px-3 py-2 rounded-md text-base font-medium"
            :class="{ 'bg-gray-800': $route.path === '/shipping' }"
          >
            Shipping Schedule
          </router-link>
          </template>
          <router-link
            v-if="user && user.roles && user.roles.isAdmin"
            to="/admin"
            class="block px-3 py-2 rounded-md text-base font-medium"
            :class="{ 'bg-gray-800': $route.path === '/admin' }"
          >
            Manage Users
          </router-link>
          <router-link
            v-if="user && user.email"
            to="/logout"
            @click="handleLogout"
            class="block px-3 py-2 rounded-md text-base font-medium"
          >
            Logout
          </router-link>
          <router-link
            v-else
            to="/login"
            class="block px-3 py-2 rounded-md text-base font-medium"
          >
            Login
          </router-link>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import { firebaseApp, db } from "./database/db.js";
export default {
  data() {
    return {
      showMenu: false,
      user: {
        email: "",
      },
    };
  },
  created() {
    firebaseApp.auth().onAuthStateChanged((user) => {
      let roles = {};
      if (user) {
        console.log("user logged in: ", user.uid);
        db.collection("roles")
          .doc(user.uid)
          .get()
          .then((doc) => {
            roles = doc.data();
            console.log(roles);
            this.user = { email: user.email, roles };
          })
          .catch((e) => {
            console.error("CLL", e);
          });
        this.user = { email: user.email, roles };
      } else {
        this.user = { email: "", roles };
      }
    });
  },
  methods: {
    handleLogout(e) {
      // this.user = { email: "" };
      console.log("logging out");
      e.preventDefault();
      firebaseApp.auth().signOut();
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="scss">
@import "./main.css";
* {
  box-sizing: border-box;
}
body {
  margin: 0;
  padding: 0;
  background: #f8f8f8;
}
#app {
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
h1,
h2,
h3,
h4,
h5 {
  color: #2c3e50;
  font-weight: bold;
}

.btn {
  background: #fa9a1c;
  color: #fff;
  border: none;
  padding: 7px 14px;
  border-radius: 4px;
  font-size: 17px;
  min-width: 100px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    background: #f78c0a;
  }
}

.btn-main {
  background: #04b950;
  color: #fff;
  &:hover {
    background: #049741;
  }
}

.btn-red {
  background: #eb3e09;
  color: #fff;
  &:hover {
    background: #cc3608;
  }
}

.btn-secondary {
  background: #807d7d;
  color: #fff;
  &:hover {
    background: #5c5a5a;
  }
}

input {
  outline: 1px solid transparent;
  transition: outline-color 0.3s ease-in-out;
  &:focus {
    outline: 1px solid blue;
  }
}

#nav {
  padding: 16px 24px;
  background: #130f10;
  // box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.267);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #fa9a1c;

  a {
    font-weight: bold;
    color: #ece3cd;
    text-decoration: none;

    &.router-link-exact-active {
      color: #fa9a1c;
    }
  }

  .nav-links {
    display: flex;
    align-items: center;
    img {
      width: 180px;
      height: auto;
      margin-right: 16px;
    }
    a {
      margin-left: 16px;
      font-size: 18px;
      padding: 0 8px;
    }
  }
}
.login-status {
  display: flex;
}
</style>
